import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetPlanejamentoOperacional(filters: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER, filters],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_COM_FILTRO(filters?.unidadeid, filters?.safraid), {});
      return data;
    },
    {
      keepPreviousData: true,
    }
  );
}

export default useGetPlanejamentoOperacional;
